module.exports = __webpack_public_path__ + "img/5.8e5234b2.png";